var slideCounter = avm.require('avast.web.slideCounter');


var infFeaturesLg = tns({
	"container": ".slider-infFeaturesLg",
	"controlsContainer": ".slider-infFeaturesLg-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"navPosition": "bottom",
	"gutter": 24,
	"slideBy": "page",
	"responsive": {
		"768": {
			"items": 2
		},
		"992": {
			"items": 1,
			"gutter": 32
		},
		"1280": {
			"items": 2
		}
	}
});
slideCounter(infFeaturesLg);


var infFeaturesSm = tns({
	"container": ".slider-infFeaturesSm",
	"controlsContainer": ".slider-infFeaturesSm-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"navPosition": "bottom",
	"gutter": 24,
	"slideBy": "page",
	"responsive": {
		"768": {
			"items": 2
		},
		"992": {
			"gutter": 32
		},
		"1280": {
			"items": 3
		}
	}
});
slideCounter(infFeaturesSm);


var articles = tns({
	"container": ".slider-articles",
	"controlsContainer": ".slider-articles-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"navPosition": "bottom",
	"loop": false,
	"slideBy": "page",
	"responsive": {
		"576": {
			"items": 2
		},
		"992": {
			"items": 3
		},
		"1366": {
			"items": 4
		}
	}
});
slideCounter(articles);


var testimonials = tns({
	"container": ".slider-testimonials",
	"controlsContainer": ".slider-testimonials-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"navPosition": "bottom",
	"gutter": 24,
	"slideBy": "page",
	"responsive": {
		"992": {
			"gutter": 32
		}
	}
});
slideCounter(testimonials);


var testimonials2 = tns({
	"container": ".slider-testimonials2",
	"controlsContainer": ".slider-testimonials2-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"navPosition": "bottom",
	"gutter": 24,
	"slideBy": "page",
	"responsive": {
		"992": {
			"gutter": 32
		}
	}
});
slideCounter(testimonials2);


var images = tns({
	"container": ".slider-images",
	"controlsContainer": ".slider-images-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"navPosition": "bottom",
	"gutter": 24,
	"slideBy": "page",
	"responsive": {
		"992": {
			"gutter": 32
		}
	}
});
slideCounter(images);


var medias = tns({
	"container": ".slider-medias",
	"mode": "gallery",
	"controlsContainer": ".slider-medias-controls",
	"navContainer": ".slider-medias-navs",
	"controlsPosition": "bottom",
	"navPosition": "bottom",
	"slideBy": "page",
	"autoplay": true,
	"autoplayButtonOutput": false,
	onInit: function() {
		stopAutoplay("slider-medias");
	}
});
slideCounter(medias);


// For medias:
// Stop autoplay while hovering above controls and navs and when these are clicked on
function stopAutoplay(name) {
	var
		sliderEl = document.querySelector('[data-name='+name+']'),
		controls = sliderEl.querySelector(".packed-control"),
		pause = function() {medias.pause();},
		play = function() {medias.play();}

	controls.addEventListener('mouseenter', pause);
	controls.addEventListener('mouseleave', play);
	controls.addEventListener('click', function() {
		pause;

		controls.removeEventListener('mouseenter', pause);
		controls.removeEventListener('mouseleave', play);
	});
};
